import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useStyles from './drawer-notices.styles';

// Validation errors the drawer can't show next to their fields, as "field label: message".
export const DrawerErrors = ({ errors }) => {
  const classes = useStyles();
  return (
    <div role="alert" className={classNames(classes.notice, classes.errors)}>
      <p className={classes.title}>Fix these to preview the price change</p>
      <ul className={classes.list}>
        {errors.map(({ fieldName, fieldLabel, message }) => (
          <li key={fieldName}>
            {fieldLabel}: {message}
          </li>
        ))}
      </ul>
    </div>
  );
};

DrawerErrors.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({ fieldName: PropTypes.string, fieldLabel: PropTypes.string, message: PropTypes.string })
  ).isRequired
};

// The preview changed more than the chosen change.
export const OutsideChangesWarning = ({ fields }) => {
  const classes = useStyles();
  return (
    <div role="status" className={classNames(classes.notice, classes.warning)}>
      <p className={classes.title}>This preview also changes other fields</p>
      <p className={classes.text}>{fields.join(', ')}. Check them before you save.</p>
    </div>
  );
};

OutsideChangesWarning.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.string).isRequired
};
